module.exports = __webpack_public_path__ + "media/images/athletes/4324-39cb61c2e7b822b248d877ad22c3e0d0.png";